import { Inject, ModelEvents, Singleton } from '@denishussar/html5-game-engine';
import {
    CardColorsEnum,
    CardLabelsEnum,
    PrintCardModel,
} from '../Models/PrintCardModel';

@Singleton
export class GameLogic {
    constructor(
        @Inject private _model: PrintCardModel,
        @Inject private _modelEvents: ModelEvents
    ) {}

    public reset(): void {
        this._model.labels = [];
        this._model.colors = [];
        this._model.lever = 'lever_up';
        this._model.press = 'press_up';
        this._model.color = CardColorsEnum.color0;
        this._model.label = CardLabelsEnum.label0;
        this._model.selectedLabel = 'not_chosen';
        this._model.selectedColor = 'not_chosen';

        for (let i = 0; i < 3; i++) {
            this._model.labels.push(CardLabelsEnum[`label${i}`]);
        }
        for (let i = 0; i < 4; i++) {
            this._model.colors.push(CardColorsEnum[`color${i}`]);
        }
    }

    public selectLabel(model: any) {
        this._model.selectedLabel = model;
    }

    public selectColor(model: any) {
        this._model.selectedColor = model;
    }

    // private _randColor = this._getRandomProp(CardColorsEnum);
    // private _randLabel = this._getRandomProp(CardLabelsEnum);
    private _isFirstLaunch = false;
    private _wrongAnswerCounter = 0;

    public getRandomCard() {
        this._model.color = this._getRandomProp(CardColorsEnum);
        this._model.label = this._getRandomProp(CardLabelsEnum);
    }

    private _checkAnswer() {
        if (
            this._model.selectedLabel === this._model.label &&
            this._model.selectedColor === this._model.color
        ) {
            return true;
        } else {
            return false;
        }
    }

    public changeLever() {
        this._model.lever = 'lever_down';
        this._model.press = 'press_down';

        if (this._checkAnswer()) {
            this._model.lever = 'lever_up';
            this._model.press = 'press_up';
            return true;
        }
        this._model.lever = 'lever_up';
        this._model.press = 'press_up';

        return false;
    }

    public isRightAnswer(): number {
        return this._wrongAnswerCounter;
    }

    private _getRandomProp(obj: object) {
        const keys = Object.keys(obj);

        return obj[keys[(keys.length * Math.random()) << 0]];
    }
}
